import React from 'react';
import { useStore } from '../../context/StoreContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiShoppingCart } from 'react-icons/fi';

export const FloatingCart = () => {
  const { cart } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  // Hide if cart is empty or if user is already on cart/checkout pages
  if (cart.length === 0 || location.pathname === '/cart' || location.pathname === '/checkout') return null;

  const itemCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <button
      onClick={() => navigate('/cart')}
      className="fixed top-1/2 right-0 -translate-y-1/2 z-[9990] bg-brand-darkSage text-white p-3 rounded-l-xl shadow-2xl hover:-translate-x-1 transition-transform duration-300 flex flex-col items-center gap-3 group border-y border-l border-white/20 cursor-pointer"
      aria-label="View Cart"
    >
      <div className="relative">
        <FiShoppingCart className="w-6 h-6 group-hover:scale-110 transition-transform" />
        <span className="absolute -top-2 -right-2 bg-brand-gold text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-lg">
          {itemCount}
        </span>
      </div>
      <span className="text-[10px] font-bold uppercase tracking-widest" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>
        View Cart
      </span>
    </button>
  );
};